export const enum ReceiverAction {
  RESPONSE = 50,
  START = 0,
  STOP = 100,
  YIELD = 25,
}
